import EnumUserStatus from "@/api/Main/dataSource/api/users/base/enums/EnumUserStatus";
import { EmployeeQueueAccessEnum } from "../enums";
import { ITirPmDropdownOption } from "tir-components";

/**Модель сотрудника */
export class EmployeeAccessModel implements ITirPmDropdownOption {
  /**Id пользователя */
  Id!: number;
  /**Имя */
  FirstName!: string;
  /**Фамилия */
  LastName!: string;
  /**Отчество */
  MiddleName!: string;
  /**Цвет аватарки */
  AvatarColor!: string;
  /**Аватарка */
  Foto!: string;
  /**Статус */
  Status!: EnumUserStatus;
  /**Доступы сотрудника */
  Accesses: boolean[] = [];

  /**Поиск */
  search(value: string) {
    const search = value.toLocaleLowerCase();
    return (
      this.FirstName.toLocaleLowerCase().includes(search) ||
      this.MiddleName.toLocaleLowerCase().includes(search) ||
      this.LastName.toLocaleLowerCase().includes(search)
    );
  }

  /**Инициалы имени */
  get Initials() {
    return `${this.FirstName?.[0].toLocaleUpperCase() || ""}${this.LastName?.[0].toLocaleUpperCase() || ""}`;
  }
  /**Имя */
  get Name() {
    return `${this.FirstName} ${this.LastName}`;
  }

  constructor(obj?: Partial<EmployeeAccessModel>) {
    if (obj) Object.assign(this, obj);
  }
}
